import { InferGetStaticPropsType, NextPage } from 'next'
import React from 'react'

import {
  REVALIDATION_PERIODS,
  STATUS_NOT_FOUND,
} from '@scentregroup/shared/constants'
import { localeToCountry } from '@scentregroup/shared/helpers/local-to-country'
import { fetchNationalStaticData } from '@scentregroup/shared/hub-components/universal-header'
import Error from '@scentregroup/shared/pages/error'

import { makeApolloClient } from '../lib/apolloClient'
import { propsOrNotFound } from '../lib/props-or-not-found'
import { GetStaticProps, GetStaticPropsContext } from '../types/next'

export const getStaticProps: GetStaticProps = async ({
  locale,
}: GetStaticPropsContext) => {
  const client = makeApolloClient()

  const headerStaticData = await fetchNationalStaticData(client, {
    country: localeToCountry(locale),
  })

  return propsOrNotFound({
    props: {
      headerStaticData,
    },
    revalidate: REVALIDATION_PERIODS.notFound,
  })
}

const NotFoundPage: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = props => (
  <Error headerStaticData={props.headerStaticData} status={STATUS_NOT_FOUND} />
)

export default NotFoundPage
